export default __webpack_public_path__ + "static/10-8c8c257fbc459a828a2a95f4fd4bdf12.png";